export const ALL_TEMPLATE_SLUG = "all";
export const DEFAULT_CATERGORY_SLUG = "trending";

export const MASTER_COMPANY_TYPENAME = "MasterCompany";
export const RECOMMENDED_TEMPLATES_SLUG = [DEFAULT_CATERGORY_SLUG, ALL_TEMPLATE_SLUG];

export const DEFAULT_TEMPLATES_CATEGORY_DESCRIPTION =
  "Personalize any template by adding your logo and a banner.";
export const DEFAULT_TEMPLATE_CATEGORY_TEXT = "Template Gallery";
export const DEFAULT_MOMENT_CATEGORY_DESCRIPTION = "Pick a moment to select items to send.";
export const DEFAULT_MOMENT_CATEGORY_TITLE = "Pick a Moment";
export const DEFAULT_MOMENT_CATEGORY_TEXT = "Moment Gallery";

export const CUSTOMER_CASE_STUDY_SLUG = "customer-case-studies";

export const SHOPS_CATEGORY = {
  slug: "myShops",
  name: "Your Existing Shops",
};

export const ALL_TEMPLATES = "All Templates";
